import BasePartialView from 'js/view-partial/base';

export default class BaseModalPartialView extends BasePartialView {
  constructor(h = {}) {
    super(h);
    this.opt = {overlay: {fillColor: '#000', opacity: 0.8}};
  }
}
